import React from 'react'
import { StyledLink } from '../../../../theme/Global'
import { COMMON_TABLE_HEADERS } from '../../../../common/constants'

const paidLeaveNotificationsAddressColumns = () => ([
  {
    Header: COMMON_TABLE_HEADERS.LOCATION_NAME,
    accessor: 'name',
    width: 350,
    minWidth: 350, // default
    maxWidth: 0, // default
    Cell: ({ cell }) => (
      <StyledLink to={`/paidLeave/details/${cell.row.original.locationId}`}>
        {cell.row.original.locationName}
      </StyledLink>
    ),
    canSort: false
  },
  {
    Header: COMMON_TABLE_HEADERS.ADDRESS,
    accessor: 'address',
    width: 450,
    minWidth: 450, // default
    maxWidth: 0, // default
    Cell: ({ cell }) => (
      <div className="text">
        {
        `${cell.row.original.locationAddress.address1} 
        ${cell.row.original.locationAddress.address2 || ''} 
        ${cell.row.original.locationAddress.city} 
        ${cell.row.original.locationAddress.state} 
        ${cell.row.original.locationAddress.zip} 
        ${cell.row.original.locationAddress.country}`
      }
      </div>
    ),
    canSort: false
  }
])

export default paidLeaveNotificationsAddressColumns
